
export enum UserOPEEnum {
  ChangePassword = 'changePassword',
  ExportAllCustomersDevices = 'exportAllCustomersDevices',
  PostLogin = 'postLogin',
  UserLogout = 'userLogout'
}
